// extracted by mini-css-extract-plugin
export default {"translation-strategy-google-logo":"translation-strategy-google-logo--1Q8fV","translationStrategyGoogleLogo":"translation-strategy-google-logo--1Q8fV"};